// React
import { useState, useEffect } from "react";
import clsx from "clsx";

// MUI
import { Stack } from "@mui/material";

// Layouts
import SmartSelector from "./SmartSelector";

const CustomCountryOption = (props) => {
	const { option, disabled = false, multipleSelected = false, selected = false } = props;
	const { image, code, abbr } = option;

	return (
		<Stack
			direction={"row"}
			className={clsx({
				"!font-sans !text-[14.5px]": true,
				"!text-default": !selected || multipleSelected,
				"!text-white": selected && !multipleSelected,
				"!text-disabled": disabled,
			})}
		>
			{image}
		</Stack>
	);
};

const InputStartAdornment = (props) => {
	const { value } = props;
	const { flagIcon = null } = value || {};
	if (!flagIcon) return null;
	return <Stack mr={"5px"}>{flagIcon}</Stack>;
};

const getCustomLabel = (option) => {
	if (!option) {
		return "";
	}
	return `${option["abbr"]}  ${option["code"]}`;
};

export default function AdvancedCountrySelector(props) {
	const {
		selectBy = "_id",
		showBy = "label",
		placeholder = "",
		disabledOptions = [],
		disabled = false,
		loading = false,
		selectorPopperProps = null,
		sx = null,
		onChange = () => {},
		onChangeNumbers = () => {},
	} = props;

	const [value, setValue] = useState(null);
	const [options, setOptions] = useState([]);

	const handleChange = (value) => {
		setValue(value);
		onChange(value);
	};

	useEffect(() => {
		const defaultData = props.data || [];
		setOptions(defaultData);

		return () => {
			setOptions([]);
		};
	}, [props.data]);

	useEffect(() => {
		onChangeNumbers("");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.selected]);

	return (
		<Stack sx={sx}>
			<SmartSelector
				selectBy={selectBy}
				showBy={showBy}
				options={options}
				disabledOptions={disabledOptions}
				selected={value}
				inputProps={{
					placeholder: placeholder,
					startAdornment: <InputStartAdornment value={value} />,
				}}
				listBoxProps={{
					sx: { maxHeight: "226px" },
				}}
				optionLabelProps={{
					formatter: (option) => getCustomLabel(option),
				}}
				renderOptionCustomProps={{
					customComponent: {
						component: <CustomCountryOption />,
					},
				}}
				popperProps={{ ...selectorPopperProps }}
				clearable
				disabled={disabled}
				loading={loading}
				onChangeAction={handleChange}
			/>
		</Stack>
	);
}
